export let COMALL_ELEMENT_TYPE = 'comall.element';
// if (typeof Symbol === 'function' && Symbol.for) {
//   const symbolFor = Symbol.for;
//   COMALL_ELEMENT_TYPE = symbolFor('comall.element');
// }
//# sourceMappingURL=CoMallSymbols.js.map